import { render, staticRenderFns } from "./PartnerCardSettings.vue?vue&type=template&id=29d0d762"
import script from "./PartnerCardSettings.vue?vue&type=script&lang=ts"
export * from "./PartnerCardSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports